'use client';
import React from 'react';
import Script from 'next/script';
import { SWIZ_COUNTRY_CODE, AUSTRIA_COUNTRY_CODE } from 'helpers/utils/constantStrings';
import { useLocale } from 'frontastic/hooks/useLocale';

const ETrackerSnippet = () => {
  const { locale } = useLocale();

  const secureCode =
    locale === SWIZ_COUNTRY_CODE
      ? process.env.NEXT_PUBLIC_ETRACKER_DARTA_SOURCE_CODE_CH
      : locale === AUSTRIA_COUNTRY_CODE
      ? process.env.NEXT_PUBLIC_ETRACKER_DARTA_SOURCE_CODE_AT
      : null;

  if (!secureCode) {
    console.warn('ETracker secure code is missing. Skipping script execution.');
    return null;
  }
  return (
    <>
      {/* eTracker Ready Function */}
      <Script
        id="eTrackerReady"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            function _etrackerOnReady() {
              window.etrackerReady = true;
            }
          `,
        }}
      />
      {/* Load the eTracker script */}
      <Script
        id="_etLoader"
        type="text/javascript"
        charSet="UTF-8"
        data-block-cookies="true"
        data-secure-code={secureCode}
        src="//code.etracker.com/code/e.js"
        async
      />
    </>
  );
};

export default ETrackerSnippet;
